/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import { fetchApiAuth } from 'core/utils/api';
import { handleError } from 'core/utils/helpers';
import { CreateEmergencyServicePayload, DeleteEmergencyServicePayload } from './types';

export const getEmergencyServices = createAsyncThunk(
    'settings/getEmergencyServices',
    async () => {
        try {
            const response = await fetchApiAuth({
                method: 'GET',
                url: '/emergency-service/emergency-services',
            });
            return response.data;
        } catch (error: unknown) {
            const errorMessage = handleError(error);
            throw errorMessage;
        }
    },
);

export const createEmergencyService = createAsyncThunk(
    'settings/createEmergencyService',
    async (payload: CreateEmergencyServicePayload, { rejectWithValue }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: '/emergency-service/create-emergency-service',
                body: payload,
            });
            message.success('Emergency service created successfully');
            return response.data;
        } catch (error) {
            const errorMessage = handleError(error);
            message.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    },
);

export const deleteEmergencyService = createAsyncThunk(
    'settings/deleteEmergencyService',
    async (payload: DeleteEmergencyServicePayload, { rejectWithValue }) => {
        try {
            const response = await fetchApiAuth({
                method: 'POST',
                url: '/emergency-service/delete-emergency-service',
                body: payload,
            });
            message.success('Emergency service deleted successfully');
            return response.data;
        } catch (error) {
            const errorMessage = handleError(error);
            message.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    },
);
